/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Floating
 * 1 = FloatingSingle
 * 2 = Fixed
 */
export enum PrecisionModels {
  Floating = 0,
  FloatingSingle = 1,
  Fixed = 2
}
